import { Component, ElementRef, Inject, NgModule, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SharedModeService } from '../shared/services/shared-mode.service';
import { DashboardService } from '../shared/services/dashboardservices/dashboard.service';
import { FormsModule, NgForm } from '@angular/forms';
import { Location } from '@angular/common';
import { AddService } from 'src/app/shared/services/userservices/add.service';
import Swal from 'sweetalert2';
import { MediaService } from 'src/app/shared/services/mediaservice/media.service';
import { SettingservicesService } from '../shared/services/settingservices/settingservices.service';
import { LoaderComponent } from '../shared/components/loader/loader.component';
declare let $: any;
@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.css',
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule],
})

export class SettingsComponent implements OnInit {
  [x: string]: any;

  @ViewChild('organizationModal') organizationModal!: ElementRef;
  @ViewChild('designationModal') designationModal!: ElementRef;
  @ViewChild('policyModal') policyModal!: ElementRef;
  @ViewChild('departmentModal') departmentModal!: ElementRef;
  @ViewChild('catmodal') catmodal!: ElementRef;
  @ViewChild('subcatmodal') subcatmodal!: ElementRef;
  @ViewChild('leavesModal') leavesModal!: ElementRef;
  @ViewChild('keysModal') keysModal!: ElementRef;
  @ViewChild('kpslistModal') kpslistModal!: ElementRef;





  private convertToBoolean(value: string): boolean {
    return value.toLowerCase() === 'true';
  }


  public showSpinner = false;
  selectedMode: any;
  user: any;
  userInfo: any;
  colormode: any;
  apidata: any;
  orgDetail: any;
  modalData: any;
  editname: any;
  editslogan: any;
  editcity: any;
  editcountry: any;
  editpostalcode: any;
  editaddress1: any;
  editaddress2: any;
  org_id: any;
  comp_leave: any;
  toggleValueCompulsoryLeave = false;
  toggleValueTLAction = 0; // 0 = Recommendation, 1 = Approval
  genderApplicability = 2; // default : Both= 2 , 0 =female, 1 =male
  editdesdescription: any;
  selectedOrg: any = null;
  isMedia = false;
  ditCom_leave: any
  refresh: any;






  constructor(
    private route: ActivatedRoute,
    private mediaService: MediaService,
    public _location: Location,
    public router: Router,
    @Inject(AddService) private addService: AddService,
    public dashboardService: DashboardService,
    private sharedmode: SharedModeService,
    private settings: SettingservicesService,

  ) {
    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.user_detail();
    const user_role = JSON.parse(this.user?.user_role?.user_roles)
    if (user_role.role_type == "Employee") {
      this.router.navigate(['/dashboard-1']);
    }
  }

  ngOnInit(): void {
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });
    this.getOrganization();
    this.getDesignation();
    this.getdep();
    this.getpolicies();
    this.getcategory();
    this.getleaves();
    this.getkeysDetail();
    this.getkpsData();
    this.showUserRole();
    this.user_refresh();
  }
  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    })
  }
  user_refresh() {
    this.dashboardService.getuserrefresh().then((value) => {
      this.refresh = value.data.user
      this.user = this.refresh;

      localStorage.setItem('user', JSON.stringify(value.data.user));
      const test_user = localStorage.getItem("user");
      const user_role = JSON.parse(this.user?.user_role?.user_roles)
      if (user_role.role_type == "Employee") {
        this.router.navigate(['/dashboard-1']);
      }
    })

  }

  isavailablefeature(type: string): boolean {
    const user_role = JSON.parse(this.user.user_role.user_roles);
    const values = user_role?.settings?.data?.values;

    switch (type) {
      case "view":
        return values?.view ?? false;
      case "add":
        return values?.add ?? false;
      case "edit":
        return values?.edit ?? false;
      case "delete":
        return values?.delete ?? false;
      default:
        return false;
    }
  }

  getOrganization() {
    this.showSpinner = true;
    this.settings.getorgdetail().then((value) => {
      this.orgDetail = value.data
      this.showSpinner = false;
    })
  }

  deleteOrg(id: any) {
    this.showSpinner = true;

    this.settings.getorgdelete(id).then((value) => {

      if (value.success == true) {


        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Deleted Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
      }
      else {
        Swal.fire({
          iconHtml: ' <img src="../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 1500,
        });
      }
      window.location.reload()

    })
  }





  openorgmodal(data: any) {

    this.modalData = data;

    const modalElement: any = this.organizationModal.nativeElement;
    $(modalElement).modal('show');

    this.org_id = this.modalData.id
    this.editname = this.modalData.name
    this.editslogan = this.modalData.slogan
    this.editcity = this.modalData.city
    this.editcountry = this.modalData.country
    this.editpostalcode = this.modalData.postal_code
    this.editstate = this.modalData.state
    this.edittype = this.modalData.type
    this.editaddress1 = this.modalData.address1
    this.editaddress2 = this.modalData.address2
  }



  onOrgSubmit(org: NgForm) {
    this.showSpinner = true;
    if (this.org_id) {
      org.value
      this.settings.orgedit(org.value, this.org_id).then((value) => {
        this.showSpinner = false;
        if (value.success == true) {
          Swal.fire({
            iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
            title: 'Organization Edit Successfully',
            showConfirmButton: false,
            timer: 1500,
          });

        } else {

          Swal.fire({
            iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 3000,
          });
        }
        window.location.reload();
      })
    }
    else {
      org.value
      this.settings.orgdetail(org.value).then((value) => {
        this.showSpinner = false;
        if (value.success == true) {
          Swal.fire({
            iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
            title: 'Organization Added Successfully',
            showConfirmButton: false,
            timer: 1500,
          });

        } else {
          Swal.fire({
            iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 3000,
          });
        }
        window.location.reload();

      })
    }
  }


  // designation private

  getDesignation() {
    this.showSpinner = true;
    this.settings.getDesdetail().then((value) => {
      this.desDetail = value.data
      this.showSpinner = false;
    })
  }


  opendesmodal(data: any) {
    this.modalData = data;
    const modalElement: any = this.designationModal.nativeElement;
    $(modalElement).modal('show');
    this.des_id = this.modalData.id
    this.editdesname = this.modalData.designation_name
    this.editdesdescription = this.modalData.description
    const selectedOrg = this.orgDetail.find((org: { name: any; }) => org.name === this.modalData.organization_name);
    if (selectedOrg) {
      this.orgSelected = selectedOrg;
    }
  }


  cleardesmodal() {
    this.onModalHidden();
    this.onModalDismissed();
  }

  onModalHidden() {
    this.des_id = null;
    this.editdesname = '';
    this.editdesdescription = '';
    this.orgSelected = null;
  }
  onModalDismissed() {
    this.des_id = null;
    this.editdesname = '';
    this.editdesdescription = '';
    this.orgSelected = null;
  }


  onDesSubmit(des: NgForm) {
    this.showSpinner = true;
    if (this.des_id) {
      des.value
      this.selectedOrg
      this.settings.desedit(des.value, this.des_id).then((value) => {
        this.showSpinner = false;
        if (value.success == true) {
          Swal.fire({
            iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
            title: 'Designation Edit Successfully',
            showConfirmButton: false,
            timer: 1500,
          });

        } else {

          Swal.fire({
            iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 3000,
          });
        }
        window.location.reload();
      })
    }
    else {
      des.value
      des.value.orgnazation
      des.value.orgnazation.id
      this.selectedOrg
      this.settings.desdetail(des.value).then((value) => {
        this.showSpinner = false;
        if (value.success == true) {
          Swal.fire({
            iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
            title: 'Designation Added Successfully',
            showConfirmButton: false,
            timer: 1500,
          });

        } else {
          Swal.fire({
            iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 3000,
          });
        }
        window.location.reload();

      })
    }
  }


  deletedes(id: any) {
    this.showSpinner = true;
    this.settings.getdesdelete(id).then((value) => {
      if (value.success == true) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Deleted Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
      }
      else {
        Swal.fire({
          iconHtml: ' <img src="../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 1500,
        });
      }
      window.location.reload()
    })

  }

  // departments
  getdep() {
    this.showSpinner = true;
    this.settings.getdepdetail().then((value) => {
      this.depDetail = value.data
      this.showSpinner = false;
    })
  }



  opendepmodal(data: any) {
    this.modalData = data;
    const modalElement: any = this.departmentModal.nativeElement;
    $(modalElement).modal('show');
    this.dep_id = this.modalData.id
    this.editdepname = this.modalData.department_name
    this.editsubdep = this.modalData.sub_department_name

  }


  cleardepmodal() {
    this.onModaldep();
    this.onModaldepDismissed();
  }

  onModaldep() {
    this.dep_id = null;
    this.editdepname = '';
    this.editsubdep = '';
  }
  onModaldepDismissed() {
    this.dep_id = null;
    this.editdepname = '';
    this.editsubdep = '';
  }


  onSubmitdep(dep: NgForm) {
    this.showSpinner = true;
    if (this.dep_id) {
      dep.value
      this.settings.depedit(dep.value, this.dep_id).then((value) => {
        this.showSpinner = false;
        if (value.success == true) {
          Swal.fire({
            iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
            title: 'Deparment Edit Successfully',
            showConfirmButton: false,
            timer: 1500,
          });

        } else {

          Swal.fire({
            iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 3000,
          });
        }
        window.location.reload();
      })
    }
    else {
      dep.value
      this.settings.depCreat(dep.value).then((value) => {
        this.showSpinner = false;
        if (value.success == true) {
          Swal.fire({
            iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
            title: 'Department Added Successfully',
            showConfirmButton: false,
            timer: 1500,
          });

        } else {
          Swal.fire({
            iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 3000,
          });
        }
        window.location.reload();

      })
    }
  }

  deletedep(id: any) {
    this.showSpinner = true;
    this.settings.getdepdelete(id).then((value) => {
      if (value.success == true) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Deleted Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
      }
      else {
        Swal.fire({
          iconHtml: ' <img src="../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 1500,
        });
      }
      window.location.reload()
    })

  }





  // policies

  getpolicies() {
    this.showSpinner = true;
    this.settings.getpolicydetail().then((value) => {
      this.policyDetail = value.data
      this.showSpinner = false;
    })
  }




  openpolicymodal(data: any) {
    this.modalData = data;
    const modalElement: any = this.policyModal.nativeElement;
    $(modalElement).modal('show');
    this.policy_id = this.modalData.id
    this.editpolicyTitle = this.modalData.policy_title
    this.editpolicydescription = this.modalData.policy_description

  }


  onPolicySubmit(policy: NgForm) {
    this.showSpinner = true;
    if (this.policy_id) {
      policy.value
      this.selectedOrg
      this.settings.policyedit(policy.value, this.policy_id).then((value) => {
        this.showSpinner = false;
        if (value.success == true) {
          Swal.fire({
            iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
            title: 'Designation Edit Successfully',
            showConfirmButton: false,
            timer: 1500,
          });

        } else {

          Swal.fire({
            iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 3000,
          });
        }
        window.location.reload();
      })
    }
    else {
      policy.value
      this.settings.policyCreate(policy.value).then((value) => {
        this.showSpinner = false;
        if (value.success == true) {
          Swal.fire({
            iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
            title: 'Policy Added Successfully',
            showConfirmButton: false,
            timer: 1500,
          });

        } else {
          Swal.fire({
            iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 3000,
          });
        }
        window.location.reload();

      })
    }
  }


  deletepolicy(id: any) {

    this.showSpinner = true;
    this.settings.getpolicydelete(id).then((value) => {
      if (value.success == true) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Deleted Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
      }
      else {
        Swal.fire({
          iconHtml: ' <img src="../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 1500,
        });
      }
      window.location.reload()
    })


  }



  // category


  getcategory() {
    this.showSpinner = true;
    this.settings.getcategorydetail().then((value) => {
      this.catDetail = value
      this.showSpinner = false;
    })
  }





  opencatmodal(data: any) {
    this.modalData = data;
    const modalElement: any = this.catmodal.nativeElement;
    $(modalElement).modal('show');
    this.category_id = this.modalData.id
    this.editcategoryName = this.modalData.name
  }

  updateIsMedia() {
    this.isMedia = !this.isMedia;
  }
  oncategorySubmit(category: NgForm) {
    this.showSpinner = true;
    if (this.category_id) {
      category.value
      this.selectedOrg
      this.settings.categoryedit(category.value, this.category_id).then((value) => {
        this.showSpinner = false;
        if (value.success == true) {
          Swal.fire({
            iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
            title: 'Designation Edit Successfully',
            showConfirmButton: false,
            timer: 1500,
          });

        } else {

          Swal.fire({
            iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 3000,
          });
        }
        window.location.reload();
      })
    }
    else {
      category.value
      this.settings.categoryCreate(category.value).then((value) => {
        this.showSpinner = false;
        if (value.success == true) {
          Swal.fire({
            iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
            title: 'Category Added Successfully',
            showConfirmButton: false,
            timer: 1500,
          });

        } else {
          Swal.fire({
            iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 3000,
          });
        }
        window.location.reload();

      })
    }
  }


  getleaves() {
    this.showSpinner = true;
    this.settings.getleavesdetail().then((value) => {
      this.leaveDetail = value?.data || [];

      // const sumPaidLeaveCount = this.leaveDetail
      //   .filter((leave: any) => leave.leave_type === 'Paid')
      //   .reduce((sum: any, leave: any) => sum + Number(leave.leave_count || 0), 0);
      // this.paidLeavesCount = sumPaidLeaveCount;
      // const sumUnpaidaidLeaveCount = this.leaveDetail
      //   .filter((leave: any) => leave.leave_type === 'Un-Paid')
      //   .reduce((sum: any, leave: any) => sum + Number(leave.leave_count || 0), 0);
      // this.unpaidLeavesCount = sumUnpaidaidLeaveCount;
      // const sumTotalLeaveCount = this.leaveDetail
      //   .reduce((sum: any, leave: any) => sum + Number(leave.leave_count || 0), 0);
      // Normalize leave_type to lowercase for comparison
      const sumPaidLeaveCount = this.leaveDetail
        .filter((leave: any) => leave.leave_type.toLowerCase() === 'paid')
        .reduce((sum: number, leave: any) => sum + Number(leave.leave_count || 0), 0);

      this.paidLeavesCount = sumPaidLeaveCount;

      const sumUnpaidLeaveCount = this.leaveDetail
        .filter((leave: any) => leave.leave_type.toLowerCase() === 'unpaid')
        .reduce((sum: number, leave: any) => sum + Number(leave.leave_count || 0), 0);

      this.unpaidLeavesCount = sumUnpaidLeaveCount;

      const sumTotalLeaveCount = this.leaveDetail
        .reduce((sum: number, leave: any) => sum + Number(leave.leave_count || 0), 0);

      this.total_leaves = sumTotalLeaveCount;

      this.showSpinner = false;
    }).catch(error => {
      Swal.fire({
        iconHtml: '<img src="../../../assets/images/error-modal.svg" alt="image">',
        title: 'Error fetching leave details:',
        showConfirmButton: false,
        timer: 3000,
      });
      this.showSpinner = false;
    });
  }


  opendleavemodal(data: any) {
    this.modalData = data;
    const modalElement: any = this.leavesModal.nativeElement;
    $(modalElement).modal('show');
    this.leave_id = this.modalData.id
    this.editleave_name = this.modalData?.leave_name
    this.leaveselected = this.modalData?.leave_type
    this.editleave_count = this.modalData?.leave_count
    if (this.modalData?.compulsary_leave == 1) {
      this.toggleValueCompulsoryLeave = true
    } else {
      this.toggleValueCompulsoryLeave = false
    }

    this.genderApplicability = this.modalData?.gender_applicability;
    this.toggleValueTLAction = this.modalData?.team_lead_action_type;

  }
  closeLeaveModal() {
    const modalElement: any = this.leavesModal.nativeElement;
    $(modalElement).modal('hide');
  }
  clearleavemodal() {
    this.onModallev();
    this.onModalleaveDismissed();
  }

  onModallev() {
    this.leave_id = null;
    this.editleave_name = '';
    this.leaveselected = null;
    this.editleave_count = '';
    this.toggleValueCompulsoryLeave = false

  }
  onModalleaveDismissed() {
    this.leave_id = null;
    this.editleave_name = '';
    this.leaveselected = null;
    this.editleave_count = '';
    this.toggleValueCompulsoryLeave = false
  }
  onaddleavesSubmit(addleaves: NgForm) {

    this.showSpinner = true;
    this.genderApplicability;
    this.toggleValueTLAction;
    this.toggleValueCompulsoryLeave;
    if (this.leave_id) {
      addleaves.value
      this.selectedOrg
      this.settings.leavesedit(addleaves.value, this.leave_id, this.toggleValueCompulsoryLeave, this.genderApplicability, this.toggleValueTLAction).then((value) => {
        this.showSpinner = false;
        if (value.success == true) {
          Swal.fire({
            iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 3000,
          });

        } else {
          Swal.fire({
            iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 3000,
          });
        }
        window.location.reload();
      })
    }
    else {
      addleaves.value
      this.settings.leaveCreate(addleaves.value, this.toggleValueCompulsoryLeave, this.genderApplicability, this.toggleValueTLAction).then((value) => {
        this.showSpinner = false;
        if (value.success == true) {
          Swal.fire({
            iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
            title: value?.message,
            showConfirmButton: false,
            timer: 5000,
          });

        } else {
          Swal.fire({
            iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 5000,
          });
        }
        window.location.reload();

      })
    }
  }
  deletedleave(id: any) {
    this.showSpinner = true;
    this.settings.leavedelete(id).then((value) => {
      if (value.success == true) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Deleted Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
      }
      else {
        Swal.fire({
          iconHtml: ' <img src="../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 1500,
        });
      }
      window.location.reload()
    })


  }

  clearcatmodal() {
    this.onModalcat();
    this.onModalcatDismissed();
  }

  onModalcat() {
    this.category_id = null;
    this.editcategoryName = '';
  }
  onModalcatDismissed() {
    this.category_id = null;
    this.editcategoryName = '';
  }

  deleteCategory(id: any) {
    this.showSpinner = true;
    this.settings.getCategorydelete(id).then((value) => {
      if (value.success == true) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Deleted Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
      }
      else {
        Swal.fire({
          iconHtml: ' <img src="../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 1500,
        });
      }
      window.location.reload()
    })


  }

  // subcategory


  subcatClick(id: any) {
    this.expense_cat_id = id

  }


  // subcategory

  getSubCategory() {
    this.showSpinner = true;
    this.settings.getSubCategorydetail().then((value) => {
      this.subCatDetail = value
      this.showSpinner = false;
    })
  }


  opensubcatmodal(data: any) {
    this.modalData = data;
    const modalElement: any = this.subcatmodal.nativeElement;
    $(modalElement).modal('show');
    this.subcategory_id = this.modalData.id
    this.editsubcategoryName = this.modalData.name
    this.editsubcategoryamount = this.modalData.amount
    this.editsubcategorydate = this.modalData.last_date
    this.editsubcategorystatus = this.modalData.status
    this.isMedia = this.modalData.is_Media
    this.expense_cat_id = this.modalData.expense_cat_id
  }


  addpolicy() {
    this.router.navigate(['/add-policy']);
  }
  addTextAutomation() {
    this.router.navigate(['/setup-text-automation']);
  }
  onsubcategorySubmit(subcategory: NgForm) {
    this.showSpinner = true;
    if (this.subcategory_id) {
      subcategory.value
      this.expense_cat_id
      if (subcategory.value.subcategory_amount == null || subcategory.value.subcategory_amount == undefined) {
        subcategory.value.subcategory_amount = 0;
      }

      if (subcategory.value.subcategory_status == null || subcategory.value.subcategory_status == undefined) {
        subcategory.value.subcategory_status = 'pending'; // Assuming 'pending' is a string
      }
      if (subcategory.value.is_Media == null || subcategory.value.is_Media == undefined) {
        subcategory.value.is_Media = 0;
      }


      this.settings.subcategoryedit(subcategory.value, this.expense_cat_id, this.subcategory_id).then((value) => {
        this.showSpinner = false;
        if (value.success == true) {
          Swal.fire({
            iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
            title: 'Sub Category Edit Successfully',
            showConfirmButton: false,
            timer: 1500,
          });

        } else {

          Swal.fire({
            iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 3000,
          });
        }
        window.location.reload();
      })
    }
    else {
      subcategory.value
      if (subcategory.value.subcategory_amount == null || subcategory.value.subcategory_amount == undefined) {
        subcategory.value.subcategory_amount = 0;
      }

      if (subcategory.value.subcategory_status == null || subcategory.value.subcategory_status == undefined) {
        subcategory.value.subcategory_status = 'pending'; // Assuming 'pending' is a string
      }

      this.expense_cat_id;
      this.settings.subcategoryCreate(subcategory.value, this.expense_cat_id).then((value) => {
        this.showSpinner = false;
        if (value.success == true) {
          Swal.fire({
            iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
            title: 'Sub Category Added Successfully',
            showConfirmButton: false,
            timer: 1500,
          });

        } else {
          Swal.fire({
            iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 3000,
          });
        }
        window.location.reload();

      })
    }
  }

  deletesubcat(id: any) {

    this.showSpinner = true;
    this.settings.getSubcategorydelete(id).then((value) => {
      if (value.success == true) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Deleted Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
      }
      else {
        Swal.fire({
          iconHtml: ' <img src="../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 1500,
        });
      }
      window.location.reload()
    })

  }

  gotoPolicyPage() {
    this.router.navigate(['/policy']);
  }

  editPolicy(data: any) {
    const uuid = data.uuid
    this.router.navigate(['/add-policy', uuid]);
  }
  formModel = {
    deviceCheck: false,
    leaveCheck: false,
    authKey:false,
    keyleave_date: ''
  };

  getkeysDetail() {
    this.showSpinner = true;
    this.settings.getkeysdetail().then((value) => {
      this.keysid = value?.data?.id
      this.leaveKey = value?.data?.leave_check
      this.leaveDate = value?.data?.leave_modify_date
      this.deviceKey = value?.data?.device_check
      this.auth_key = value?.data?.authenticator_key
      if (this.leaveKey == 1) {
        this.leaveKey = 'true'
      } else {
        this.leaveKey = 'false'
      }
      if (this.deviceKey == 1) {
        this.deviceKey = 'true'
      } else {
        this.deviceKey = 'false'
      }


      if(this.auth_key == 1){
          this.auth_key = 'true'
      }else{
          this.auth_key = 'false'
      }



      this.showSpinner = false;
    })
  }


  getData() {
    this.showSpinner = true;
    this.addService.getStaticData().then((value) => {
      this.office_roles = value.data.officeRolesId
      this.office_roles_array = Object.entries(this.office_roles).map(([id, role_names]) => {
        return { id: Number(id), role_names };
      });
      this.countryList = value.data.country;
    });
  }

  getkpsData() {
    this.showSpinner = true;
    this.settings.getkpsData().then((value) => {
      this.kpsData = value?.data;
      this.getData()
      this.showSpinner = false;
    })
  }






  onaddkeysSubmit(formValues: any) {
    this.showSpinner = true;
    if (this.keysid) {
      this.device_check = formValues.deviceCheck
      this.leave_check = formValues.leaveCheck
      this.auth_key = formValues.authKey
      this.leave_date = formValues.keyleave_date
      this.settings.keysedit(this.device_check, this.leave_check,this.auth_key, this.leave_date, this.keysid).then((value) => {
        this.showSpinner = false;
        if (value.success == true) {
          Swal.fire({
            iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 3000,
          });

        } else {

          Swal.fire({
            iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 3000,
          });
        }
        window.location.reload();
      })
    }
    else {
      this.device_check = formValues.deviceCheck
      this.leave_check = formValues.leaveCheck
      this.auth_key = formValues.authKey
      this.leave_date = formValues.keyleave_date
      this.settings.checkCreate(this.device_check, this.leave_check,this.auth_key, this.leave_date).then((value) => {
        this.showSpinner = false;
        if (value.success == true) {
          Swal.fire({
            iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
            title: value?.message,
            showConfirmButton: false,
            timer: 5000,
          });

        } else {
          Swal.fire({
            iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 5000,
          });
        }
        window.location.reload();

      })
    }

  }

  clearkeymodal() {
    this.onModalkey();
    this.onModalkeyDismissed();
  }

  onModalkey() {
    this.keysid = null;
    this.formModel.leaveCheck = false
    this.formModel.deviceCheck = false
        this.formModel.authKey = false
    this.formModel.keyleave_date = ''
  }
  onModalkeyDismissed() {
    this.keysid = null;
    this.formModel.leaveCheck = false
    this.formModel.deviceCheck = false
    this.formModel.authKey = false
    this.formModel.keyleave_date = ''
  }
  opendkeysmodal() {
    const modalElement: any = this.keysModal.nativeElement;
    $(modalElement).modal('show');
    this.keysid
    this.leaveKey
    this.deviceKey
    this.auth_key
    this.formModel.leaveCheck = this.convertToBoolean(this.leaveKey);
    this.formModel.deviceCheck = this.convertToBoolean(this.deviceKey);
    this.formModel.authKey = this.convertToBoolean(this.auth_key);
    this.formModel.keyleave_date = this.leaveDate
    this.showSpinner = false;
  }

  deletedkey(id: any) {
    this.showSpinner = true;
    var id = id
    this.settings.getkeydelete(id).then((value) => {
      if (value.success == true) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Deleted Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
      }
      else {
        Swal.fire({
          iconHtml: ' <img src="../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 1500,
        });
      }
      window.location.reload()
    })
  }

  toggleChangedCL(event: any): void {
    this.toggleValueCompulsoryLeave = event.target.checked;
    if (this.toggleValueCompulsoryLeave == true) {
      this.editCom_leave = 'Yes';
    } else {
      this.ditCom_leave = 'No';
    }
  }
  toggleChangedTLAction(event: any) {
    this.toggleValueTLAction = event.target.checked ? 1 : 0;
    console.log('Team Lead Action Type:', this.toggleValueTLAction);
  }

  onaddkpsSubmit(kpslist: NgForm) {
    this.showSpinner = true;
    if (this.kpsdata_id) {
      kpslist.value
      this.settings.kpsListedit(kpslist.value, this.kpsdata_id).then((value) => {
        this.showSpinner = false;
        if (value.success == true) {
          Swal.fire({
            iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 5000,
          });

        } else {
          Swal.fire({
            iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 5000,
          });
        }
        window.location.reload();
      })
    }
    else {
      kpslist.value
      this.settings.kpsCreate(kpslist.value).then((value) => {
        this.showSpinner = false;
        if (value.success == true) {
          Swal.fire({
            iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
            title: value?.message,
            showConfirmButton: false,
            timer: 5000,
          });

        } else {
          Swal.fire({
            iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 5000,
          });
        }
        window.location.reload();

      })
    }
  }

  deletedkps(id: number) {
    this.showSpinner = true;
    var id = id
    this.settings.getkpsdelete(id).then((value) => {
      if (value.success == true) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Deleted Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
        window.location.reload();

      }
      else {
        Swal.fire({
          iconHtml: ' <img src="../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 1500,
        });
      }

    })
    this.showSpinner = false;

  }

  opendkpsmodal(data: any) {
    this.kpsdata = data
    const modalElement: any = this.kpslistModal.nativeElement;
    $(modalElement).modal('show');
    this.kpsdata_id = this.kpsdata?.id
    this.editkps_name = this.kpsdata?.title
    this.editemployee_role = this.kpsdata?.type
    this.editkps_value = this.kpsdata?.value
    this.showSpinner = false;
  }



  addUserRole() {
    this.router.navigate(['/user-role'], {
      state: { data: "Create new" }  // Optionally, pass the entire data as state
    });
  }



  showUserRole() {
    this.showSpinner = true;
    this.settings.getUSerRole().then((value) => {
      if (value.success == true) {
        this.user_Roles = value.data
        this.user_Roles = value.data.map((role: any) => ({
          ...role,
          parsedUserRoles: this.parseUserRoles(role.user_roles)
        }));

      }
      else {
        Swal.fire({
          iconHtml: ' <img src="../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 1500,
        });
      }
      this.showSpinner = false;

    }).catch(() => {
      this.showSpinner = false;
    });
  }

  parseUserRoles(user_roles: any): any {
    try {
      if (typeof user_roles === 'string') {
        return JSON.parse(user_roles);
      }
      return user_roles; // already parsed object
    } catch (e) {
      console.error('Failed to parse user_roles:', user_roles);
      return null;
    }
  }

  onEditClick(data: any): void {
    this.router.navigate(['/user-role'], {
      state: { data }  // Optionally, pass the entire data as state
    });
  }

  deleteRole(id: any) {
    this.showSpinner = true;
    const role_id = id;
    this.settings.deleteUSerRole(role_id).then((value) => {
      if (value.success == true) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: value?.message,
          showConfirmButton: false,
          timer: 5000,
        }).then(() => {
          window.location.reload(); // reload only after alert is closed
        });

      }
      else {
        Swal.fire({
          iconHtml: ' <img src="../../../assets/images/error-modal.svg"  alt="image" >',
          title: value?.message,
          showConfirmButton: false,
          timer: 5000,
        }).then(() => {
          window.location.reload(); // reload only after alert is closed
        });
      }
    }).catch(() => {
      this.showSpinner = false;
      Swal.fire({
        iconHtml: '<img src="../../../assets/images/error-modal.svg" alt="image">',
        title: 'Unexpected error occurred.',
        showConfirmButton: false,
        timer: 5000,
      }).then(() => {
        window.location.reload(); // reload only after alert is closed
      });
    });

    this.showSpinner = false;

  }


  viewRole(data: any) {
    this.router.navigate(['/user-role-view'], {
      state: { data }  // Optionally, pass the entire data as state
    });
  }


}
